module.exports = __webpack_public_path__ + "img/part3-icon2.6d713536.png";